module.exports = __webpack_public_path__ + "images/accents/accent-seat-management@1x-15e3aa0887fc3cdccbe49851e9a945e5.webp";